export const async = bundle => (loc, cb) => {
  bundle().then(module => cb(null, module.default));
};
export const convertToNonHash = () => {
  if (document.location.hash.startsWith('#/')) {
    const match = document.location.hash.match(/^#\/(.*)/i);
    if (match) {
      const pathname = [...match][1];
      document.location.replace('/' + pathname);
    } else document.location.replace('/');
  }
};

export const scrollToTop = (prevState, nextState) => {
  if (nextState.location.action !== 'POP') {
    window.scrollTo(0, 0);
  }
};



// WEBPACK FOOTER //
// ./js/components/helpers/routerUtils.js